import Component from './TwitterAnalyticsPublicSummary.vue'
export default Component
